/* eslint new-cap: ['error', { 'capIsNew': false }] */
import React from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import {
  composePurchaseRegNumber,
  composeSaleRegNumber,
  dateTimePickerFormat,
  getFromTab,
  locationFallThrough,
  MainComponentBox,
  navTo,
} from '../../../../util/util.jsx';
import {
  addDealEvent,
  addNewProduct,
  clearDealStore,
  deleteDealEvent,
  editDealEvent,
  loadDeal,
  tryToSaveDeal,
  tryToUpdateDeal,
  updateDealField,
  updateDealProductField,
} from '../store/deal.store';
import { lockEntity, unlockEntity } from '../../../../store/collaboration';
import { storeFiles } from '../store/files.store';
import { Col, Form, Grid, Modal, NavItem, Panel, Row } from 'react-bootstrap';
import {
  Button,
  Checkbox,
  DateTimePicker2 as DateTimePicker,
  FormControl,
} from '../../../form/FormControls.jsx';
import RefPicker from '../../../dict/simple/select/DictPicker.jsx';
import Label from '@/component/form/Label.jsx';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import { Audit } from '../audit/Audit.jsx';
import BaseDealEdit, {
  baseDealMapDispatchToProps,
  baseDealMapStateToProps,
} from '../BaseDealEdit.jsx';
import Files from '../files/Files.jsx';
import UserPicker from '@/component/managment/users/Select.jsx';
import { List, Map } from 'immutable';
import { handleFormChanged } from '@/store/allaround.store.js';
import DealHeader from '../DealHeader';
import { validateRoleConfig } from '../../../auth/RoleConfigFilter.jsx';
import { stopLinking } from '@/store/links.store';
import FancyInput from '@/component/form/numinput/index';
import ProductsContainerList from './ProductsContainerList';
import ExpensesTotal from './../expenses/ExpensesTotal';
import AvailableSince, { VERSIONS } from '@/util/version';
import { creationTimeTooltip } from '@/util/util';
import { putError as putErrorAction } from '@/store/error.store';
import { hasApprovedPayments, updateProductPaymentCounterparty }
  from '../payments/PaymentsContainer';
import { REF_PATH as EXPENSES_TYPE_REF_PATH } from '@/component/dict/complex/expensestype/Const';
import RoleConfigFilter from '@/component/auth/RoleConfigFilter.jsx';
import FinanceTabContainer from '../purchaseFinTable/FinanceTabContainer';

import _ from 'lodash';
import audit from '../../../../../style/audit.png';

moment.locale('en');
momentLocalizer();

function clearCheckBoxes(formName, event) {
  $.each($(`#${formName} input:checkbox`), (idx, obj) => {
    if (obj != event.target) {
      // eslint-disable-next-line no-param-reassign
      obj.checked = false;
    }
  });
}

class PurchaseSaleEdit extends BaseDealEdit {
  constructor(props) {
    super(props);
    this.updateDealFieldDebounced = _.debounce(this.updateDealField.bind(this), 250);
    this.onContractNumberChange = this.onContractNumberChange.bind(this);
    this.onBuyerChange = this.onBuyerChange.bind(this);
    this.onSellerChange = this.onSellerChange.bind(this);
    this.selectPayments = this.selectPayments.bind(this);
    this.selectDeal = this.selectDeal.bind(this);
    this.handleDealStatusChange = this.handleDealStatusChange.bind(this);
    if (getFromTab().endsWith('payments')) {
      this.state = { tabSelected: 'payments' };
    } else {
      this.state = { tabSelected: 'deal' };
    }
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    if (this.props.params.dealId == 'new') {
      this.updateDealField('interestRate', this.props.interestrate);
    }
    this.getDisplayData(this.props);
  }

  componentWillUpdate(props, state) {
    if (super.componentWillUpdate) {
      super.componentWillUpdate(props, state);
    }
    if (state.hidden != this.state.hidden ||
      this.state.tabSelected != state.tabSelected) {
      this.getDisplayData(props, state);
    }
  }

  componentWillReceiveProps(props) {
    if (super.componentWillReceiveProps) {
      super.componentWillReceiveProps(props);
    }
    locationFallThrough(`${props.type} ${props.deal.get('regNumber', '') || ''}`,
      `/deals/${props.type}/${props.params.dealId}`);
    if (props.deal && (props.deal != this.props.deal || props.lock != this.props.lock)) {
      this.getDisplayData(props);
    }
    if (this.props.interestrate != props.interestrate) {
      if (this.props.params.dealId == 'new') {
        this.updateDealField('interestRate', props.interestrate);
      }
    }
  }

  shouldComponentUpdate(props, newState) {
    if (newState == this.state
      && props.lock == this.props.lock
      && props.products && this.props.products
      && props.products != this.props.products) {
      return false;
    }
    return true;
  }

  handleDealStatusChange(evt) {
    clearCheckBoxes('DealStatus', evt);
    if (evt && evt.currentTarget) {
      if (evt.currentTarget.name != 'dealCanceled') {
        this.updateDealField('dealCanceled', false);
      } else {
        this.updateDealField('dealCanceled',
          evt && evt.currentTarget ? evt.currentTarget.checked : false);
      }
    }
  }

  selectPayments() {
    this.setState({ tabSelected: 'payments' });
  }

  selectPL = () => {
    this.setState({ tabSelected: 'PL' });
  }
  selectFinTab = () => {
    this.setState({ tabSelected: 'Fin' });
  }

  selectDeal() {
    this.setState({ tabSelected: 'deal' });
  }

  selectMultiNodal = () => this.setState({ tabSelected: 'Multinodal' });

  updateDealField(field, value) {
    this.props.updateDealField(field, value);
  }

  onContractNumberChange(e) {
    this.updateDealFieldDebounced('regNumber',
      e && e.target && e.target.value ? e.target.value : '');
  }

  onBuyerChange(e) {
    updateProductPaymentCounterparty(this.props.type, this.props.expensestypes,
      this.props.products, (productIdx, payments) =>
        this.props.updateDealProduct(productIdx, 'payments', payments), e ? e.value : undefined);
    this.updateDealField('buyer', e ? e.value : '');
  }

  onSellerChange(e) {
    updateProductPaymentCounterparty(this.props.type, this.props.expensestypes,
      this.props.products, (productIdx, payments) =>
        this.props.updateDealProduct(productIdx, 'payments', payments), e ? e.value : undefined);
    this.updateDealField('supplier', e ? e.value : '');
  }

  validateSave(data) {
    if (!data.regNumber || !data.regNumber.trim()) {
      if (data.contactSigned) {
        this.props.putError({
          alert: true,
          message: 'Contract number is necessary because the deal Status is Contract signed',
        });
        return false;
      }
      if (data.products) {
        const approvedPayments = data.products.filter(p => hasApprovedPayments(p.payments));
        if (approvedPayments && approvedPayments.length > 0) {
          this.props.putError({
            alert: true,
            message: 'Contract number is necessary because the deal has approved payments',
          });
          return false;
        }
      }
    }

    if (document.getElementsByClassName('due-amount-invalid').length > 0) {
      this.props.putError({
        alert: true,
        message: 'Excess multiple payment due amount',
      });
      return false;
    }
    return true;
  }

  getDisplayData(props, state = this.state) {
    const data = props.deal;
    const dealFound = data && data.size && (data.get('id') || props.params.dealId == 'new');
    const isNew = props.params.dealId == 'new';

    const canEdit = validateRoleConfig(['myDeals#2', 'allDeals#2'], data);
    const canDelete = validateRoleConfig(['myDeals#3', 'allDeals#3'], data);
    const assignResponsibleAllowed = validateRoleConfig(['dealsAssignResponsible']);
    const locked = props.lock
      ? (props.lock.get('entityId') == data.get('id')
        && props.lock.get('ownerId') != props.currentUser) : false;
    const isReadonly = this.props.readonly || locked || !canEdit;
    const hasLinks = props.products && props.products.findIndex && props.products.findIndex(p =>
      !p.get(`${props.type}Link`, new List()).filter(l => !l.get('hidden')).isEmpty()) > -1;
    let name;
    const grayScreen =
      (<div
        style={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          background: 'lightgray',
          opacity: '0.9',
          zIndex: '10',
          left: '0',
          display: state.hidden ? 'inherit' : 'none',
        }}
      />);
    if (data && data.get('id')) {
      let regNumber = null;
      if (props.type == 'purchase') {
        regNumber = composePurchaseRegNumber(
          data,
          'regNumber',
          null);
      } else {
        regNumber = composeSaleRegNumber(
          data,
          'regNumber',
          null);
      }
      name = (<span onClick={this.selectDeal}>
        {props.type ? props.type.charAt(0).toUpperCase() + props.type.slice(1)
          : ''}&nbsp;&nbsp;&nbsp;{regNumber === null ? '' : regNumber}
      </span>);
    } else {
      name = <div>New {props.type}</div>;
    }
    let component = <MainComponentBox wide />;
    const paymentsTab = [];
    paymentsTab.push(<NavItem
      onClick={this.selectPayments}
      className={`${state.tabSelected == 'payments' ? 'selected-deal' : 'unselected-deal'}`}
    >
      <div className={'transition-deal-button'}>Payments</div>
    </NavItem>);
    paymentsTab.push(
      <RoleConfigFilter permissions={['viewProfitability']}>
        <NavItem
          onClick={this.selectPL}
          className={`${state.tabSelected == 'PL' ? 'selected-deal' : 'unselected-deal'}`}
        >
          <div className={'transition-deal-button'}>Profit/Loss</div>
        </NavItem>
      </RoleConfigFilter>
    );
    if (props.type == 'purchase' && !isNew) {
      paymentsTab.push(<NavItem
        onClick={this.selectFinTab}
        className={`${state.tabSelected == 'Fin' ? 'selected-deal' : 'unselected-deal'}`}
      >
        <div className={'transition-deal-button'}>Finance</div>
      </NavItem>);
    }
    if (props.type == 'purchase') {
      paymentsTab.push(<NavItem
        onClick={this.selectMultiNodal}
        className={`${state.tabSelected == 'Multinodal' ? 'selected-deal' : 'unselected-deal'}`}
      >
        <div className={'transition-deal-button'}>Multi-nodal</div>
      </NavItem>);
    }
    const header = (<DealHeader
      name={name}
      onNameClick={this.selectDeal}
      deal={data}
      id={data && data.get('id') ? data.get('id') : null}
      lock={props.lock}
      openModal={this.openModal}
      hidden={state.hidden}
      cancel={this.handleCancelButton}
      dealType={props.type}
      onFromSubmitHandler={this.onFromSubmitHandler}
      disabled={locked || (!canEdit && !assignResponsibleAllowed)}
      allowDelete={canDelete}
      allowDuplicate={canEdit}
      nameClass={`${state.tabSelected == 'deal' ? 'selected-deal' : 'unselected-deal'}`}
      tabs={paymentsTab}
    />);
    if (dealFound) {
      component = (<MainComponentBox withBreadcrumb secondNavBar={header} wide>
        <Grid style={{ fontSize: 13 }} className={'container-wide'}>
          {grayScreen}
          <Row style={{ display: 'flex' }}>
            <Col md={12} style={{ zIndex: '1' }}>
              <Form
                id="dealsForm" horizontal
                className="dealsForm"
                onChange={this.formChanged}
              >
                <div>
                  {state.tabSelected == 'Fin' ?
                    <FinanceTabContainer dealId={props.params.dealId} />
                    : <div />}
                  <Row className={`${state.tabSelected == 'Fin' ? 'hidden' : ''} deals-first-row`}>
                    <Col md={12}>
                      <Panel
                        style={{
                          height: '100%',
                          borderBottom: 0,
                          boxShadow: 'none',
                        }}
                        className="dealsEditTopPanel"
                      >
                        <Row>
                          <Col md={6}>
                            <Row>
                              <Col md={6}>
                                <Label
                                  label="Contract number" vertical sm={12}

                                  labelStyle={{ float: 'left', marginRight: 10 }}
                                >
                                  <FormControl
                                    key={`regNumber_${data && data.get('dealLoadedTime')}`}
                                    name="regNumber" id="regNumber"
                                    onChange={this.onContractNumberChange}
                                    disabled={isReadonly}
                                    defaultValue={data ? data.get('regNumber') : undefined}
                                  />
                                </Label>
                              </Col>
                              <Col md={3}>
                                <DatePicker
                                  type={props.type} data={data}
                                  onChange={val => {
                                    const date = val ?
                                      moment(val).format(dateTimePickerFormat) : undefined;
                                    props.updateDealField(`${props.type}Date`, date);
                                    props.handleFormChanged();
                                  }}
                                  disabled={isReadonly}
                                />
                              </Col>
                              <Col md={3}>
                                <Label
                                  label="Creator" vertical sm={12}

                                >
                                  {creationTimeTooltip(data, <UserPicker
                                    name="creator"
                                    defaultValue={isNew ? props.currentUser : data.get('creator')}
                                    disabled
                                  />)}
                                </Label>
                              </Col>
                            </Row>
                            {props.type == 'purchase' ?
                              <Row>
                                <Col md={6}>
                                  <Label
                                    vertical
                                    label="Origin"
                                    sm={12}

                                  >
                                    <RefPicker
                                      dict="origin" name="origin"
                                      defaultValue={data.get('origin')}
                                      disabled={isReadonly}
                                    />
                                  </Label>
                                </Col>
                                <Col md={6}>
                                  <Label
                                    vertical
                                    label="Seller"
                                    sm={12}

                                  >
                                    <RefPicker
                                      dict="supplier"
                                      name="supplier"
                                      defaultValue={data.get('supplier')}
                                      disabled={isReadonly}
                                      onChangeFunc={this.onSellerChange}
                                    />
                                  </Label>
                                </Col>
                              </Row>
                              :
                              <Row>
                                <Col md={6}>
                                  <Label
                                    vertical
                                    label="Destination"
                                    sm={12}

                                  >
                                    <RefPicker
                                      dict="origin"
                                      name="destination"
                                      defaultValue={data.get('destination')}
                                      disabled={isReadonly}
                                    />
                                  </Label>
                                </Col>
                                <Col md={6}>
                                  <Label
                                    vertical
                                    label="Buyer"
                                    sm={12}

                                  >
                                    <RefPicker
                                      dict="buyer"
                                      name="buyer"
                                      defaultValue={data.get('buyer')}
                                      disabled={isReadonly}
                                      onChangeFunc={this.onBuyerChange}
                                    />
                                  </Label>
                                </Col>
                              </Row>
                            }
                          </Col>
                          <Col md={6}>
                            <Row>
                              <Col md={6}>
                                <Row>
                                  <Col md={props.type == 'purchase' ? '7' : '12'}>
                                    <Label
                                      label="Our bank" vertical sm={12}

                                    >
                                      <RefPicker
                                        dict="bank"
                                        name="ourBank"
                                        defaultValue={data.get('ourBank')}
                                        disabled={isReadonly}
                                      />
                                    </Label>
                                  </Col>
                                  <Col
                                    md={5}
                                    style={{
                                      display: props.type == 'purchase' ?
                                        'block' : 'none',
                                    }}
                                  >
                                    <Label
                                      label="Interest rate, %" vertical sm={12}

                                    >
                                      <FancyInput
                                        className="form-control"
                                        disabled={isReadonly}
                                        name="interestRate"
                                        fraction={2}
                                        positive
                                        negative={false}
                                        value={data.get('interestRate')}
                                        onChange={(e, val) =>
                                          this.updateDealFieldDebounced('interestRate', val)}
                                      />
                                    </Label>
                                  </Col>
                                </Row>
                                <Label
                                  label="Counterparty bank" vertical sm={12}

                                >
                                  <RefPicker
                                    dict="bank" name="counterpartyBank"
                                    defaultValue={data.get('counterpartyBank')}
                                    disabled={isReadonly}
                                  />
                                </Label>
                              </Col>
                              <Col md={6} id="DealStatus" className="dealStatus">
                                <Label
                                  label="Deal status" vertical sm={12}

                                >
                                  <div className={'deal-status-panel'}>
                                    <Col md="8" className="deal-status-block">
                                      <Checkbox
                                        key={data
                                          ? `agreedVerbally-${data.get('agreedVerbally')}`
                                          : 'agreedVerbally'
                                        }
                                        name="agreedVerbally"
                                        defaultChecked={data.get('agreedVerbally')}
                                        onClick={this.handleDealStatusChange}
                                        disabled={isReadonly}
                                      >
                                        Agreed verbally
                                      </Checkbox>
                                      <Checkbox
                                        key={data
                                          ? `agreedInWriting-${data.get('agreedInWriting')}`
                                          : 'agreedInWriting'
                                        }
                                        name="agreedInWriting"
                                        defaultChecked={data.get('agreedInWriting')}
                                        onClick={this.handleDealStatusChange}
                                        disabled={isReadonly}
                                      >
                                        Agreed in writing
                                      </Checkbox>
                                      <Checkbox
                                        key={data
                                          ? `contactSigned-${data.get('contactSigned')}`
                                          : 'contactSigned'
                                        }
                                        name="contactSigned"
                                        defaultChecked={data.get('contactSigned')}
                                        onClick={this.handleDealStatusChange}
                                        disabled={isReadonly}
                                      >
                                        Contract signed
                                      </Checkbox>
                                      <Checkbox
                                        key={data
                                          ? `dealCanceled-${data.get('dealCanceled')}`
                                          : 'dealCanceled'
                                        }
                                        name="dealCanceled"
                                        defaultChecked={data.get('dealCanceled')}
                                        onClick={this.handleDealStatusChange}
                                        title={hasLinks ?
                                          'Can not cancel deal with links present' : undefined}
                                        disabled={isReadonly || hasLinks || isNew}
                                      >
                                        Deal canceled
                                      </Checkbox>
                                    </Col>
                                    <Col
                                      md={4}
                                      style={{ display: 'flex', alignItems: 'center',
                                        justifyContent: 'flex-end' }}
                                    >
                                      <div
                                        className={'transport-buttons'}
                                      >
                                        <Button
                                          bsSize="xsmall"
                                          bsStyle={data.get('isArchived') ? 'danger' : undefined}
                                          style={{
                                            visibility: data.get('isArchived')
                                              ? 'visible' : 'hidden',
                                          }}
                                          disabled
                                          id="isArchived"
                                          onClick={() =>
                                            this.props.updateDealField('isArchived',
                                              !data.get('isArchived'))}
                                          title="Archive"
                                        >
                                          Archive
                                        </Button>
                                        <br /><br />
                                        <Button
                                          bsSize="xsmall"
                                          bsStyle={data.get('hasDispute') ? 'primary' : 'gray'}
                                          style={{ fontSize: '12px' }}
                                          disabled={isReadonly}
                                          id="dispute"
                                          onClick={() => {
                                            props.updateDealField('hasDispute',
                                              !data.get('hasDispute'));
                                            props.handleFormChanged();
                                          }}
                                          title="Dispute"
                                        >
                                          Dispute
                                        </Button>
                                      </div>
                                    </Col>
                                  </div>
                                </Label>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            <Label
                              vertical
                              label="Responsible"
                              sm={12}

                            >
                              <UserPicker
                                name="responsibles"
                                multi
                                defaultValue={isNew ? List.of(props.currentUser) :
                                  data.get('responsibles')}
                                disabled={locked || !assignResponsibleAllowed}
                              />
                            </Label>
                          </Col>
                          <Col md={6}>
                            <Label
                              vertical
                              label="Producer"
                              sm={12}

                            >
                              <RefPicker
                                dict="producer"
                                name="producers"
                                multi
                                defaultValue={data.get('producers')}
                                onChangeFunc={(v) => {
                                  this.updateDealFieldDebounced('producers',
                                    v.map(val => val.value));
                                }}
                                disabled={isReadonly}
                              />
                            </Label>
                          </Col>
                        </Row>
                      </Panel>
                    </Col>
                  </Row>

                  {state.tabSelected != 'Fin' && <Row>
                    <fieldset id="products">
                      <ProductsContainerList
                        dealType={props.type}
                        tabSelected={state.tabSelected}
                        startAtomsLinking={props.startAtomsLinking}
                        disabled={isReadonly}
                      />
                    </fieldset>
                  </Row>
                  }
                  {!isReadonly && state.tabSelected == 'deal' ?
                    <Row className="add-new-product-row">
                      <Col
                        md={6} mdOffset={props.type == 'sale' ? 6 : 0}
                        style={{ textAlign: 'center' }}
                      >
                        <Button
                          id="addNewProductBtn"
                          bsStyle="primary"
                          onClick={this.addProduct}
                          style={{ width: 280, height: 60, fontSize: 22, fontWeight: 600 }}
                        >
                          Add New Product
                        </Button>
                      </Col>
                    </Row>
                    : ''
                  }
                  {state.tabSelected != 'PL' && state.tabSelected != 'Multinodal' &&
                    <div style={{ display: 'flex' }} className={'deal-footer'}>
                      <Col
                        md={6}
                        xs={12}
                      >
                        <Row className={'deal-documents-row'}>
                          <Col
                            xs={12}
                            className={'deal-documents-label'}
                          >
                        Do you have a document?
                          </Col>
                          <Col xs={12} style={{ padding: '10px 15px 5px' }}>
                            <Documents
                              label="Documents" type="USUAL" dealType={props.type}
                              disabled={isReadonly}
                            />
                            <AvailableSince version={VERSIONS.Orithia}>
                              <Panel>
                                <AvailableSince version={VERSIONS.VasyaFinal}>
                                  <RoleConfigFilter permissions={['audit']}>
                                    <Audit
                                      title={`Audit of ${props.type}`}
                                      module={props.type}
                                      buttonStyle={{ padding: 0, float: 'right' }}
                                      entityId={data === undefined ? null : data.get('id')}
                                    >
                                      <div>
                                        <img src={audit} className={'audit-icon'} alt={'Audit'} />
                                        View history of changes
                                      </div>
                                    </Audit>
                                  </RoleConfigFilter>
                                </AvailableSince>
                              </Panel>
                            </AvailableSince>
                          </Col>
                        </Row>
                      </Col>
                      {props.products && props.products.filter(p => !p.get('hidden')).size > 0 ?
                        <Col
                          md={6}
                          xs={12}
                          style={{
                            float: props.type == 'sale' ? 'left' : 'right',
                            borderLeft: '1px solid #DFDFDF',
                          }}
                        >
                          <Row
                            style={{
                              height: '100%',
                            }}
                          >
                            <ExpensesTotal
                              deal={props.deal}
                              dealType={props.type}
                            />
                          </Row>
                        </Col>
                        : <Col
                          xs={12}
                          md={6}
                        >
                          <Row className={'deal-documents-row'}>
                            <Col
                              xs={12}
                              className={'deal-documents-label'}
                            />
                          </Row>
                        </Col>
                      }
                    </div>
                  }
                </div>
                <Checkbox
                  name="hidden" id="hidden" onChange={() => ({})}
                  checked={state.hidden} style={{ display: 'none' }}
                />
              </Form>
            </Col>
          </Row>
        </Grid>
      </MainComponentBox>);
    }
    this.setState({ component });
  }

  render() {
    let isReadonly = false;
    if (this.props.deal) {
      const canEdit = validateRoleConfig(['myDeals#2', 'allDeals#2'], this.props.deal);
      const locked = this.props.lock
        ? (this.props.lock.get('entityId') == this.props.deal.get('id')
          && this.props.lock.get('ownerId') != this.props.currentUser) : false;
      isReadonly = this.props.readonly || locked || !canEdit;
    }

    const floatingButtons = (<div className="deal-actions-float">
      <Button
        id="dealCancel"
        className="deal-actions"
        onClick={this.handleCancelButton}
      >
        Cancel
      </Button>
      {!isReadonly ?
        <Button
          id="dealSave"
          className="deal-actions"
          bsStyle="primary"
          onClick={this.onFromSubmitHandler}
          disabled={this.props.saving}
        >
          Save
        </Button>
        : ''}</div>);
    return (<div>
      {this.renderKickOutInfo()}
      <Modal bsSize="small" show={!!this.state.showModal} onHide={this.closeModal}>
        <Modal.Body>
          Are you sure you want to {this.state.hidden ?
            'restore' : 'delete'} this {this.props.type}?
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="danger" onClick={this.yesButton}>Yes</Button>
          <Button onClick={this.closeModal}>No</Button>
        </Modal.Footer>
      </Modal>
      {floatingButtons}
      {this.renderQuestion()}
      {this.bulkDuplicatesQuestion()}
      {this.state.component ? this.state.component : ''}
    </div>);
  }

  routerWillLeave(routeTo) {
    if (!validateRoleConfig(['myDeals#2', 'allDeals#2'], this.props.deal)) {
      return true;
    }
    return super.routerWillLeave(routeTo);
  }
}

export default connect((state, props) => ({
  deal: state.getIn(['data', 'deals', 'deal'], new Map()),
  transports: state.getIn(['data', 'deals', 'list', 'transport'], new Map()),
  sales: state.getIn(['data', 'deals', 'list', 'sale'], new Map()),
  purchases: state.getIn(['data', 'deals', 'list', 'purchase'], new Map()),
  lock: state.getIn(['data', 'locks', props.type, props.params.dealId.toString()]),
  files: state.getIn(['data', 'deals', 'files']),
  // eslint-disable-next-line
    formChanged: state.getIn(['allaround', 'formChanged']),
  products: state.getIn(['data', 'deals', 'deal', 'products'], new List()) || new List(),
  currentUser: Number(state.getIn(['session', 'id'])),
  autosaved: state.getIn(['allaround', 'autosaved']),
  loggedIn: state.getIn(['session', 'state']) == 'LOGGED_IN',
  expensestypes: state.getIn(['references', 'simple', EXPENSES_TYPE_REF_PATH], new List()),
  ...baseDealMapStateToProps(state),
  saving: state.getIn(['allaround', 'saving'], false),
  interestrate: state.getIn(['references', 'interestrate', 'value'], 0),
}),
(dispatch, props) => ({
  cancel() {
    const fromTab = getFromTab();
    if (fromTab == 'positionbook') {
      navTo('/reports/positionBook?fromDeal=1');
      return;
    }
    if (fromTab == 'positionmap') {
      navTo('/reports/positionmap?fromDeal=1');
      return;
    }
    if (fromTab == 'unifieddeals') {
      navTo('/reports/unifieddeals?fromDeal=1');
      return;
    }
    if (fromTab) {
      navTo(`/deals/${fromTab}`);
      return;
    }
    navTo(`/deals/${props.dealFrom}`);
  },
  tryToSave(formData, type, callGoBack, dontReload) {
    const fromTab = getFromTab();
    tryToSaveDeal(dispatch, formData, type, fromTab ? false : callGoBack, dontReload);
    if (fromTab && callGoBack) {
      navTo(`/deals/${fromTab}`);
    }
  },
  tryToUpdate(formData, type, id, callGoBack, dontReload) {
    const fromTab = getFromTab();
    tryToUpdateDeal(dispatch, formData, type, id, fromTab ? false : callGoBack, dontReload);
    if (fromTab == 'positionbook' && callGoBack) {
      navTo('/reports/positionbook?fromDeal=1');
      return;
    }
    if (fromTab == 'positionmap' && callGoBack) {
      navTo('/reports/positionmap?fromDeal=1');
      return;
    }
    if (fromTab && callGoBack) {
      navTo(`/deals/${fromTab}`);
    }
  },
  loadDeal(type, id) {
    loadDeal(dispatch, type, id);
  },
  clearDeal() {
    clearDealStore(dispatch, props.type);
  },
  storeFiles(files, type) {
    storeFiles(dispatch, files, type);
  },
  addDealEvent(event) {
    addDealEvent(dispatch, event);
  },
  deleteDealEvent(event) {
    deleteDealEvent(dispatch, event);
  },
  editDealEvent(oldEvent, newEvent) {
    editDealEvent(dispatch, oldEvent, newEvent);
  },
  addNewProduct() {
    addNewProduct(dispatch);
  },
  lockEntity(entity) {
    lockEntity(dispatch, entity);
  },
  unlockEntity(entity) {
    unlockEntity(dispatch, entity);
  },
  handleFormChanged() {
    handleFormChanged(dispatch);
  },
  updateDealField(field, value) {
    updateDealField(dispatch, props.type, field, value);
  },
  updateDealProduct(productIdx, field, value) {
    updateDealProductField(dispatch, props.type, productIdx, field, value);
  },
  putError(error) {
    putErrorAction(dispatch, error);
  },
  stopLinking() {
    stopLinking(dispatch);
  },
  ...baseDealMapDispatchToProps(dispatch, props),
}))(PurchaseSaleEdit);

const Documents = props =>
  <Files
    label={props.label}
    type={props.type}
    dealType={props.dealType}
    disabled={props.disabled}
  />;

Documents.propTypes = {
  label: React.PropTypes.string,
  type: React.PropTypes.string,
  dealType: React.PropTypes.string,
  disabled: React.PropTypes.bool,
};

const DatePicker = props => <Label
  label="Contract date" vertical sm={12}

>
  <DateTimePicker
    time={false}
    format={dateTimePickerFormat}
    name={`${props.type}Date`}
    defaultValue={props.data && props.data.get(`${props.type}Date`)
      ? new Date(props.data.get(`${props.type}Date`))
      : undefined}
    disabled={props.disabled}
    onChange={props.onChange}
  />
</Label>;
DatePicker.propTypes = {
  data: React.PropTypes.object,
  type: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  onChange: React.PropTypes.func,
};
